import React from "react";
import { useQuery } from "@tanstack/react-query";
import { apiRoot } from "services/src/config";
import CommonCard from "components-v2/kpi/common-card";


import { HOME_CARD_CONTENT } from "@/modules/home/constants";

export default function LoggingDisciplineCard({ onClick, cardData, tagId }) {
  const { data, isLoading } = useQuery({
    queryKey: ["logging-discipline", tagId],
    queryFn: async () => {
      const response = await apiRoot.get("kpi/logging-discipline", {
        params: tagId ? { tagId } : undefined,
      });
      return response.data;
    },
  });

  const discipline = data?.loggingDiscipline ?? 0;
  const presentDays = data?.presentDays ?? 0;
  const onTimeDays = data?.onTimeDays ?? 0;
  const delayedDays = data?.delayedDays ?? 0;



  const { title, description } = HOME_CARD_CONTENT.loggingDiscipline;

  return (
    <CommonCard
      title={title}
      info={description}
      onClick={onClick}
      cardData={{
        title: title,
        description: description,
        value: isLoading ? "0" : discipline,
        unit: "%",
        details: [
          { label: "Present Days", value: `${presentDays} days` },
          { label: "On-time Days", value: `${onTimeDays} days` },
          { label: "Delayed Days", value: `${delayedDays} days` }
        ],
      }}
      percentage={discipline}
      isLoading={isLoading}

    />
  );
}
